import _Promise from 'babel-runtime/core-js/promise';
import _regeneratorRuntime from 'babel-runtime/regenerator';
import _asyncToGenerator from 'babel-runtime/helpers/asyncToGenerator';
import _classCallCheck from 'babel-runtime/helpers/classCallCheck';
import _createClass from 'babel-runtime/helpers/createClass';
export var AuthInterceptor = function () {
  function AuthInterceptor(keycloakService) {
    _classCallCheck(this, AuthInterceptor);

    if (!AuthInterceptor.keycloakService) {
      AuthInterceptor.keycloakService = keycloakService;
    }
  }

  /**
   * Adds the Authorization header with Bearer and token.
   * The method is async and will wait for the accesstoken to be acquired from the keycloak service before returning
   * @param config - the request.
   * @returns {Promise<*>}
   * @constructor
   */


  _createClass(AuthInterceptor, [{
    key: 'authBearerHeader',
    value: function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(config) {
        var accessToken;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return AuthInterceptor.keycloakService.getToken();

              case 2:
                accessToken = _context.sent;

                config.headers['Authorization'] = 'Bearer ' + accessToken;
                return _context.abrupt('return', config);

              case 5:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function authBearerHeader(_x) {
        return _ref.apply(this, arguments);
      }

      return authBearerHeader;
    }()
  }, {
    key: 'authBearerHeaderError',
    value: function () {
      var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(error) {
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                return _context2.abrupt('return', _Promise.reject(error));

              case 1:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function authBearerHeaderError(_x2) {
        return _ref2.apply(this, arguments);
      }

      return authBearerHeaderError;
    }()
  }]);

  return AuthInterceptor;
}();
AuthInterceptor.keycloakService = null;


// WEBPACK FOOTER //
// ./src/interceptors/AuthInterceptor.js